import { isIframe } from '@sravni/react-utils';
import { WebViewUserManager, IframeUserManager, UserManager } from '@sravni/utils/lib/auth';
import isWebview from 'is-ua-webview';

export const getUserManager = () => {
    if (isIframe()) {
        return new IframeUserManager();
    }

    if (isWebview(navigator.userAgent || navigator.vendor)) {
        return new WebViewUserManager();
    }

    return new UserManager();
};
